import angular from 'angular';
import { RogersSlippageReportContainerComponent } from './rogers-slippage-report-container.component';
import { RogersSlippageDetailReportComponent } from './rogers-slippage-detail-report.component';
import { RogersSlippageSummaryReportComponent } from './rogers-slippage-summary-report.component';

export const RogersSlippageReportModule = angular
    .module("apex.mainApp.rogersDashboard.slippageReport", [])
    .component("apexRogersSlippageReportContainer", RogersSlippageReportContainerComponent)
    .component("apexRogersSlippageDetailReport", RogersSlippageDetailReportComponent)
    .component("apexRogersSlippageSummaryReport", RogersSlippageSummaryReportComponent)
    .name;
